import { useQuery } from '@tanstack/react-query';

import { QUERY_KEYS } from '@/v2/constants/QueryKeys';
import getFeatureFlags from '@/modules/api/featureFlags/getFeatureFlags.endpoint';

const thirtyMinutes = 30 * 60 * 1000;

export default function useFeatureFlagsQuery() {
  return useQuery({
    queryKey: [QUERY_KEYS.FEATURE_FLAGS],
    queryFn: getFeatureFlags,
    staleTime: thirtyMinutes,
    refetchOnWindowFocus: false,
    meta: {
      notification: {
        error: "We couldn't load your configuration. Please try again.",
      },
    },
  });
}
